import React, { useState } from 'react';
import moment from 'moment';
import styles from './StatusPill.styles';
import { AllocationStatus } from 'shared/models/enums/AllocationStatus';
import { Button, Popover, PopoverBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faMultiply } from '@fortawesome/pro-solid-svg-icons';

const Status = ({ status, allocationStatusSummation, targetId, isPopoverOpen, togglePopover, closePopover }) => {
  switch (status) {
    case AllocationStatus.Active:
      const showExpiryPopover = allocationStatusSummation?.isSubscriptionExpiringSoon && targetId;
      return (
        <div>
          <div
            className={`status-pill active`}
            id={showExpiryPopover ? 'row-' + targetId : undefined}
            style={showExpiryPopover ? { cursor: 'pointer' } : {}}
          >
            Active
            {allocationStatusSummation?.isSubscriptionExpiringSoon && (
              <FontAwesomeIcon icon={faTriangleExclamation} className={`mr-2 mt-1 icon-on ml-2`} />
            )}
          </div>
          {showExpiryPopover && (
            <Popover
              placement="bottom"
              target={'row-' + targetId}
              trigger="legacy"
              isOpen={isPopoverOpen}
              toggle={togglePopover}
              style={{ minWidth: 250 }}
            >
              <PopoverBody>
                <div className="container-fluid p-0" style={{ fontSize: 12 }}>
                  <div className="row">
                    <div className="col">
                      <strong>UPCOMING</strong>
                    </div>
                    <div className="col">
                      <Button
                        type="button"
                        aria-label="Close"
                        color="link"
                        style={{ cursor: 'pointer' }}
                        className="p-0 mr-2 mt-1 icon-on ml-2 float-right"
                        onClick={closePopover}
                      >
                        <FontAwesomeIcon icon={faMultiply} />
                      </Button>
                    </div>
                  </div>
                  <div className="row mt-1">
                    <div className="col">Subscription End Date&nbsp;</div>
                    <div className="col-5">
                      <div className="w-100 p-0">
                        <div className="float-right">
                          {allocationStatusSummation?.subscriptionExpiryDate &&
                            moment(allocationStatusSummation?.subscriptionExpiryDate).format('M/DD/YYYY')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </PopoverBody>
            </Popover>
          )}
        </div>
      );
    case AllocationStatus.Waitlisted:
      return <div className={`status-pill waitlisted`}>Waitlisted</div>;
    case AllocationStatus.Pending:
      return <div className={`status-pill pending`}>Pending</div>;
    case AllocationStatus.Terminated:
      return <div className={`status-pill terminated`}>Terminated</div>;
    case AllocationStatus.Cancelling:
      return <div className={`status-pill cancelling`}>Cancelling</div>;
    default:
      return <div className={`status-pill none`}>No Allocations</div>;
  }
};

const StatusPill = ({ status, fullWidth, allocationStatusSummation, targetId }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const togglePopover = () => {
    setIsPopoverOpen(prev => !prev);
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div css={styles} style={fullWidth ? { width: '100%' } : { alignSelf: 'self-end' }}>
      <Status
        status={status}
        allocationStatusSummation={allocationStatusSummation}
        targetId={targetId}
        isPopoverOpen={isPopoverOpen}
        togglePopover={togglePopover}
        closePopover={closePopover}
      />
    </div>
  );
};

export default StatusPill;
